import { storeCreator } from '@/utils/store/store.utils';

interface State {
  pendingTab: string | null;
  setPendingTab: (tab: string | null) => void;
}

const useStore = storeCreator<State>((set) => ({
  pendingTab: null,

  setPendingTab: (tab: string | null) => set(() => ({
    pendingTab: tab,
  })),
}));

export default useStore;
